module.exports = __webpack_public_path__ + "img/photo_240720778_1.1d625d4c.jpg";